import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#69005b',
  width = '100%',
  className = '',
  viewBox = '0 0 30 30',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2">
        <path
          fill={fill}
          d="M10.876,43.022c.321-.328.415-.342,2.438-.342,1.822,0,1.882.007,2.15.141a.91.91,0,0,1,.556.911.993.993,0,0,1-.509.9c-.188.121-.3.127-2.083.141a18.381,18.381,0,0,1-2.109-.054,1.06,1.06,0,0,1-.442-1.695Zm4.112,6.33c-3.61,0-3.737.013-4.031.275a1.185,1.185,0,0,0-.342.931,1.158,1.158,0,0,0,.616.8,21.622,21.622,0,0,0,3.77.08l3.208-.04.616-.1a1.026,1.026,0,0,0,.208-1.634c-.355-.315-.335-.315-4.045-.315Zm14.961,8.714a4.469,4.469,0,0,1-3.422,3.851c-.482.121-.65.127-11.579.121-10.568,0-11.11-.007-11.519-.121a4.8,4.8,0,0,1-1.493-.67A5.41,5.41,0,0,1,.8,60.149a5.758,5.758,0,0,1-.67-1.474C.007,58.227,0,58.046,0,47.061,0,36.136,0,35.9.121,35.426a4.517,4.517,0,0,1,3.429-3.3c.489-.107,22.24-.127,22.769-.02a4.478,4.478,0,0,1,3.188,2.438c.516,1.025.469-.1.489,12.1C30.008,54.4,30,57.664,29.948,58.066Zm-5.719-12.4a1.192,1.192,0,0,0-.516-.77,5.5,5.5,0,0,0-1.038-.114c-.83-.04-.924-.054-1.192-.208-.415-.241-.529-.509-.536-1.226a5.329,5.329,0,0,0-1.694-3.784,6.3,6.3,0,0,0-2.719-1.681,14.47,14.47,0,0,0-2.625-.121c-2.873-.033-3.516.027-4.494.415a5.913,5.913,0,0,0-3.576,4.18,29.09,29.09,0,0,0-.127,4.307c-.027,4.206,0,4.829.268,5.66a5.845,5.845,0,0,0,4.326,3.912c.616.114,8.184.141,8.954.033a5.546,5.546,0,0,0,3.4-1.735,5.666,5.666,0,0,0,1.46-2.579A45.756,45.756,0,0,0,24.229,45.661Z"
          transform="translate(0 -32.04)"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
